import {createUseStyles} from "react-jss";
import {colors} from "../../theme";

export const useStyles = createUseStyles({
	root: {
	},
	row:{
		marginBottom: "0px",
	},
	inputsWrapper: {
		display: "flex",
		width: "100%",
	},
	inputLabel: {
		width: "100%",
		flexGrow: 1,
	},
	delete: {
		color: colors.delete,
		cursor:"pointer",
		marginBottom: "10px"
	},
	add: {
		color:"#0073aa",
		cursor: "pointer",
		marginTop: "15px",
		marginBottom: "15px",
	}
});